import React, { FC } from "react"
import ReimbursementsModal from "../../views/reimbursements/ReimbursementsModal"
import L10n from "../../../lib/carrot-l10n"
import { useHistory } from "react-router-dom"
import { FormProvider, useForm } from "react-hook-form"
import FieldNames from "../../../utils/FieldNames"
import { useSelector } from "react-redux"
import { getHasPendingIvfRequirements } from "../../../derivedSelectors"
import { CarrotRoute, getReimbursementUrl } from "utils/CarrotUrls"
import { getBenefitConfiguration } from "../../../reducers/benefitConfiguration"
import { FeatureConfiguration } from "../../../types/benefitConfiguration"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type ReimbursementsModalContainerProps = {
  onClose?: () => void
  expenseId?: string
  onFinish?: () => void
}

type ReimbursementJourney = {
  id: string
  title: string
  filter?: (config: FeatureConfiguration) => boolean
}

const reimbursementJourneys: ReimbursementJourney[] = [
  {
    id: "ADOPTION",
    title: l`Adoption`,
    filter: (c) => c.isAdoptionEnabled
  },
  {
    id: "GC",
    title: l`Gestational carrier arrangement`,
    filter: (c) => c.isGcEnabled
  },
  {
    id: "PRESERVATION",
    title: l`Fertility preservation`
  },
  {
    id: "IVF",
    title: l`Fertility care: IVF`
  },
  {
    id: "IUI",
    title: l`Fertility care: IUI`
  },
  {
    id: "PATHFINDING",
    title: l`Something else`
  }
]

const ReimbursementsModalContainer: FC<ReimbursementsModalContainerProps> = ({
  onClose = () => {},
  expenseId = null,
  onFinish = () => {}
}) => {
  const history = useHistory()
  const formMethods = useForm({
    mode: "onChange",
    defaultValues: {
      [FieldNames.REIMBURSEMENT_TYPE.valueOf()]: ""
    }
  })
  const { handleSubmit } = formMethods

  const showIvfRequirements = useSelector(getHasPendingIvfRequirements)
  const onSubmit = handleSubmit(async ({ reimbursementType }) => {
    const redirectUrl = getReimbursementUrl(
      reimbursementType === "IVF" && showIvfRequirements ? CarrotRoute.IvfRequirements : CarrotRoute.Upload,
      expenseId,
      reimbursementType
    )
    history.push(redirectUrl)
    onFinish()
  })

  const benefitConfiguration = useSelector(getBenefitConfiguration)
  const filteredReimbursementJourneys = reimbursementJourneys.filter(
    (c) => !c.filter || c.filter(benefitConfiguration.featureConfig)
  )
  return (
    <FormProvider {...formMethods}>
      <ReimbursementsModal
        onClose={onClose}
        reimbursementJourneys={filteredReimbursementJourneys}
        onSubmit={onSubmit}
      />
    </FormProvider>
  )
}

export { ReimbursementsModalContainer }
